import { cloudChiprApi } from "../../../../../services/cloudchipr.api";
import { wrapSelectorWithLanguage } from "@/store/utils/wrapSelectorWithLanguage";

export const getExplainWithAiAnomalyByIdSelector = wrapSelectorWithLanguage(
  cloudChiprApi.endpoints
    .getUsersMeOrganisationsCurrentResourceExplorerAnomalyByAnomalyId.select,
);
